import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const testimonials = [
  { quote: "....", name: "...", role: "..." },
  { quote: "....", name: "...", role: "..." },
  { quote: "....", name: "...", role: "..." },
];

export default function Testimonials() {
  return (
    <section
      id="testimoni"
      className="relative bg-forest text-parchment py-24 md:py-32 overflow-hidden"
      data-testid="testimonials-section"
    >
      <div
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/34256958/pexels-photo-34256958.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940')",
          backgroundSize: "cover",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="font-arabic text-3xl md:text-4xl text-gold leading-loose"
          >
            وَمَا تَوْفِيقِي إِلَّا بِاللَّهِ
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="mt-6 font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.1]"
          >
            Cerita dari yang<br />
            <span className="italic text-gold">telah dipercayakan.</span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, delay: i * 0.12 }}
              className="relative p-8 md:p-10 rounded-2xl border border-gold/30 bg-forest/40 backdrop-blur-sm lift"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="absolute -top-4 left-8 text-gold bg-forest p-1 rounded" size={32} />
              <blockquote className="text-parchment/90 leading-relaxed text-base md:text-lg italic">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-gold/20">
                <p className="font-serif-display text-xl text-parchment">{t.name}</p>
                <p className="mt-1 text-sm text-parchment/60">{t.role}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
